document.addEventListener("DOMContentLoaded", function () {
    console.log("section-article-video.js loaded")

    const $articleVideo = $("section.article-video")
    const $articleVideoWrapper = $articleVideo.find(".wrapper")
    const $idleVideoOverlay = $articleVideoWrapper.find(".idle-overlay")
    const $video = $articleVideoWrapper.find("video")

    // console.log("$articleVideo", $articleVideo)
    // console.log("$articleVideoWrapper", $articleVideoWrapper)
    // console.log("$idleVideoOverlay", $idleVideoOverlay)

    $idleVideoOverlay.on("click", function () {
        $idleVideoOverlay.fadeOut(200)
        if(!$video) return
        $video[0].play()
    })

    if($video) {
        $video.on("ended", function () {
            $idleVideoOverlay.fadeIn(200)
        })
    }
})
